import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { FormGroupDirective, UntypedFormControl } from '@angular/forms';

import intlTelInput from 'intl-tel-input';

import { getServerErrorForField } from '../../helpers/form-helper';

@Component({
  selector: 'app-phone-subform',
  templateUrl: './phone-subform.component.html',
  styleUrls: ['./phone-subform.component.scss'],
})
export class PhoneSubformComponent implements AfterViewInit, OnChanges {
  DEFAULT_COUNTRY = 'hu';
  PREFERRED_COUNTRIES = ['hu'];

  @Input() title?: string;
  @Input() placeholder: string = '';
  @Input() hint: string = '';
  @Input() controlName = 'phone';

  control!: UntypedFormControl;

  @ViewChild('phone', { static: true }) inputElement!: ElementRef;

  constructor(
    readonly rootFormGroup: FormGroupDirective,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.ngOnChanges();
    // initialize International Telephone Input
    intlTelInput(this.inputElement.nativeElement, {
      initialCountry: this.DEFAULT_COUNTRY,
      preferredCountries: this.PREFERRED_COUNTRIES,
      nationalMode: false,
      autoHideDialCode: false,
    });
    this.cdr.detectChanges();
  }

  useBasicDataPhone(phone?: string) {
    if (phone) {
      this.control.setValue(phone);
    }
  }

  ngOnChanges(): void {
    this.control = this.rootFormGroup.form.get(
      this.controlName
    ) as UntypedFormControl;
  }

  get(controlName: string): UntypedFormControl | undefined {
    return this.rootFormGroup.form.get(controlName) as
      | UntypedFormControl
      | undefined;
  }

  getServerError(fieldName: string): any {
    return getServerErrorForField(this.rootFormGroup.form, fieldName);
  }
}
